import { render, staticRenderFns } from "./ChannelConversionRate.vue?vue&type=template&id=23a13837&scoped=true&"
import script from "./ChannelConversionRate.vue?vue&type=script&lang=js&"
export * from "./ChannelConversionRate.vue?vue&type=script&lang=js&"
import style0 from "./ChannelConversionRate.vue?vue&type=style&index=0&id=23a13837&lang=less&scoped=true&"
import style1 from "./ChannelConversionRate.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a13837",
  null
  
)

export default component.exports